import { Text, DataList, DataItem } from '@cad-arc';
import { PillUnit } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';
import { UnitsDisplay } from '../../common/components/units-display';

export const UnitsSummary = observer(function UnitsSummary({
    units,
    label,
    ghostUnitIds,
}: {
    units: PillUnit[];
    label: string;
    ghostUnitIds?: number[];
}): React.ReactElement {
    return (
        <DataList>
            <DataItem
                dataKey={
                    <Text variant="headingXs" style={{ whiteSpace: 'nowrap' }}>
                        {label}
                    </Text>
                }
                style={{ alignItems: 'baseline' }}
            >
                <UnitsDisplay
                    units={units}
                    minNumberToDisplay={12}
                    wrap={true}
                    ghostUnitIds={ghostUnitIds}
                />
            </DataItem>
        </DataList>
    );
});
